import { useTranslation } from "react-i18next";

import { Card, CardContent } from "@/components/ui/v2/card";

function CampaignJobBoardDetailError() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="py-10 text-center">
        <p className="text-sm text-muted-foreground">
          {t("errors.jobBoardNotFound", {
            defaultValue: t("errors.somethingWentWrong"),
          })}
        </p>
      </CardContent>
    </Card>
  );
}

export default CampaignJobBoardDetailError;
